import React from 'react';
import { HeaderTemplate, Stepper } from 'web-library';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';
import ExamTitle from '../../modules/examRegistration/components/ExamTitle';
import ExamViewSelectedSubjects from '../../modules/examRegistration/components/ExamViewSelectedSubjects';

interface ViewSelectedSubjectsPageProps {
  routeSteps: { label: string }[];
}

const ViewSelectedSubjects = ({ routeSteps }: ViewSelectedSubjectsPageProps) => (
  <>
    <ExamTitle />
    <HeaderTemplate>
      <ExamTypeUuidDisplay />
      <div>
        <Stepper activeStep={1} steps={routeSteps} />
      </div>
    </HeaderTemplate>
    <ExamViewSelectedSubjects />
  </>
);

export default ViewSelectedSubjects;
